module.exports = {
  APP_VERSION_MAJOR: 11, // Max is 99
  APP_VERSION_MINOR: 5, // Max is 99
  APP_VERSION_PATCH: 3, // Max is 99
  BUILD_VERSION: 1, // Max is 999
};
